import React from "react";
import type { FeedbackFormProps } from "./types";
import { StarRating } from "./StarRating";
import { IssuesSelection } from "./IssuesSelection";

export const FeedbackForm: React.FC<FeedbackFormProps> = ({
  rating,
  hoveredRating,
  selectedIssues,
  otherFeedback,
  options,
  isSubmitting,
  onRatingChange,
  onHoverRating,
  onHoverLeave,
  onIssueToggle,
  onFeedbackChange,
  onFinalSubmit,
}) => {
  return (
    <div className="w-full transition-opacity duration-300">
      <h2 className="text-lg sm:text-xl font-bold mb-1 font-editorial italic text-center">
        How was your call?
      </h2>
      <p className="text-xs text-gray-600 mb-3 sm:mb-4 text-center">
        Your feedback helps us improve.
      </p>

      <StarRating
        rating={rating}
        hoveredRating={hoveredRating}
        isSubmitting={isSubmitting}
        onRatingChange={onRatingChange}
        onHover={onHoverRating}
        onHoverLeave={onHoverLeave}
      />

      {rating > 0 && rating < 5 && (
        <div className="w-full animate-in fade-in slide-in-from-top-4 duration-500">
          <IssuesSelection
            options={options?.flat}
            selectedIssues={selectedIssues}
            onToggle={onIssueToggle}
          />

          <div className="w-full mb-3 sm:mb-4">
            <p className="text-xs font-semibold mb-1.5 text-left w-full">
              Any other feedback? (Optional)
            </p>
            <textarea
              className="w-full p-2 text-xs sm:text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#10333B] bg-white resize-none"
              rows={3}
              placeholder="Tell us more..."
              value={otherFeedback}
              onChange={(e) => onFeedbackChange(e.target.value)}
            />
          </div>

          <div className="flex gap-3 w-full">
            <button
              onClick={onFinalSubmit}
              className="w-full py-2 px-3 rounded-xl text-xs sm:text-sm font-bold text-[#F6F4E5] bg-[#10333B] hover:bg-[#0d2a31] active:bg-[#0a2228] transition-colors uppercase tracking-wider cursor-pointer"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

